import { type } from '@testing-library/user-event/dist/type';
import React, { useState } from 'react'
import SideNav from './SideNav';

type propsType = {
    viewTab: JSX.Element,
    addTab: JSX.Element,
    viewBtn: string,
    addBtn: string,
    icon: JSX.Element | null,
    pageHeading: string,
    pageDescription: string

}

const MasterPageTab = (props: propsType) => {
    const [activeTab, setActiveTab] = useState('view');
    let TabLayout;

    if (activeTab === 'view') TabLayout = props.viewTab
    if (activeTab === 'add') TabLayout = props.addTab

    return (
        <SideNav>
            <div className="mt-8 lg:mt-12">
                <div className="flex items-center space-x-2">
                    {props?.icon}
                    <h1 className="text-2xl font-semibold">{props.pageHeading}</h1>
                </div>
                <p className='text-gray-500 mt-2'>{props.pageDescription} </p>

                <div className="my-4 flex items-center space-x-2">
                    <div className={`tab ${activeTab === 'view' && 'tab-active'}`} onClick={() => setActiveTab('view')}>
                        {props.viewBtn}
                    </div>

                    <div className={`tab ${activeTab === 'add' && 'tab-active'}`} onClick={() => setActiveTab('add')}>
                        {props.addBtn}
                    </div>
                </div>
                <div className="my-4">
                    {TabLayout}
                </div>
            </div>
        </SideNav>
    )
}

export default React.memo(MasterPageTab)